import { colorsToFontColorClass, TextDesignator } from "components/DesignSystem"

/**
 *  Determine the CSS class that would correspond with certain
 *  background designator. The class will be compatible with our
 *  Design System and our tailwind configuration.
 */
export function determineTextClass(designator: TextDesignator) {
  if (designator === "inherit") {
    return "text-inherit"
  }

  if (designator === "transparent") {
    return "text-transparent"
  }

  return colorsToFontColorClass[designator]
}
